import i18n from 'i18next';
import Container from 'typedi';
import {initReactI18next} from 'react-i18next';
import {LANGUAGE} from '@/constants';
import {ConfigService} from '@/services';
import en from './en';
import jp from './jp';

const resources = {en, jp};
const configService = Container.get(ConfigService);

i18n.use(initReactI18next).init({
  initImmediate: false,
  debug: false,
  resources: resources,
  lng: configService.language,
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
  },
});

export let i18nKey = resources[i18n.language as LANGUAGE];

i18n.on('languageChanged', (lng: LANGUAGE) => {
  configService.setLanguage(lng);
  i18nKey = resources[lng];
});

export default i18n;
